import {useTranslation} from "react-i18next";
import {useState} from "react";

import OrderByHeaders from "components/ordering/OrderByHeaders";
import DateDisplay from "components/datetime/DateDisplay";

const TableRoutes = ({items, itemsShown, setItemsShown, buttonsTB, setButtonsTB, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");

    const [checkAll, setCheckAll] = useState(false);
    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };
    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };
    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShown.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="sticky-top border-bottom-sticky" key="-1" style={{width: "30px", ...stickyHeaderStyle}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShown.map((item, index) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick} className="cursor-pointer">
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            <DateDisplay date={item.created_at} title={true} />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>{item.email}</td>
                        <td>{item.zone.name}</td>
                        <td>{_Tc(`routeUnloadStatus.${item.status}`)}</td>
                        <td>
                            <DateDisplay date={item.started_at} title={true} />
                        </td>
                        <td>
                            <DateDisplay date={item.opened_at} title={true} />
                        </td>
                        <td>
                            <DateDisplay date={item.completed_at} title={true} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableRoutes;
